import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {   
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
    InputGroup, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate, yearsPast } from "../../helpers/backend_helper"
import { EXIT_INTERVIEWS, EMPLOYEES } from 'helpers/url_helper';
import * as url from 'helpers/url_helper';

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory } from 'react-router-dom';

    const AddExitInterview = () => {
        const [empTitle, setEmpTitle] = useState('');
        const [exitInterviews, setExitInterviews] = useState([])
        const history = useHistory();

        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [CompanyID, setCompanyID] = useState("")
        const [departmentcode, setDepartmentCode] = useState('')
        const [userError, setUserError] = useState(true);
        const [isloading, setIsloading] = useState(false);
        const [addressforcorrespondencies, setAddressforfurtherCorrespondecies] = useState("")
        const [lastworkingdate, setLastWorkingDate] = useState("")
        const [documentID, setDocumentID] = useState('')
        const today = formatDate(new Date());
        toastr.options = TOAST_OPTIONS;


        const handleSubmitInterview = (e) => {
            if (lastworkingdate == ""){
                toastr.error("Lat working date must not be blank!");
            } else if (addressforcorrespondencies == ""){
                toastr.error("Address for correspondencies must not be blank!")
            } else{
                setIsloading(true)
                const exitData = {
                    'employeeno'        :   empNo,
                    'address'           :   addressforcorrespondencies,
                    'dateOfLastWorking' :   lastworkingdate,
                    'date'              :   today,
                }

                axios.post(EXIT_INTERVIEWS +"?company="+ CompanyID, JSON.stringify(exitData), HRConfig)
                    .then(function(response){     
                        if(response.status == '201'){
                            setDocumentID(response.data.SystemId)
                            toastr.success("Exit Interview No: "+ response.data.no+" created successfully!" ); 
                            setTimeout(function(){ history.push(`/exit-interview-details/${response.data.SystemId}`)} ,3000 );
                        }else{
                            toastr.success("Could not initiate exit interview. Please consult your administrator" )
                            setIsloading(false);
                        }
                    })
                    .catch(function (error) {
                        console.log(error)
                        toastr.error(error.response.data.error.message);
                        setIsloading(false);
                    })
                    .then(function () {                
                });
            }
        }

        useEffect(() => {
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                const EmployeeNo = obj.uid;
                setCompanyID(obj.activeCompany); 
                axios.get(url.EMPLOYEES2 + "?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setDepartmentCode(response.data.value[0].Department_Code);
                            setUserError(false);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                        console.log(error);
                })
                // axios.get(`${EXIT_INTERVIEWS}?$filter=employeeNo eq '${EmployeeNo}'`, HRConfig).then((r)=>{ setExitInterviews(r.data.value); console.log(r.data.value); }).catch((e)=>{ console.log(e) })   
            }
        },[]);

        return (
            <LoadingOverlay
            active={isloading}
            spinner={<ClimbingBoxLoader />}
            text='Please wait...'
            >
                <div className="page-content">
                    <MetaTags>
                    <title>Exit Interview | {url.APPNAME}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Exit Interview" />
                        {(exitInterviews.length < 1) && (
                        <Row>
                        <Col xl={4}>
                            <Card>
                                <CardBody>
                                    <CardTitle>Employee Details</CardTitle>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th scope="col"> Number</th>
                                                        <td scope="col"> {empNo} </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"> Name</th>
                                                        <td scope="col">{empName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">Position</th>
                                                        <td scope="col">{empTitle}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">Department</th>
                                                        <td scope="col">{departmentcode}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>                                                      
                                </CardBody>
                            </Card>
                            </Col>
                            <Col xl={8}>
                                <Card>
                                    <CardBody>
                                        <CardTitle>Exit Interview Details</CardTitle>
                                        <Row>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Last Working Date</label>
                                                    { <Flatpickr
                                                        className="form-control"
                                                        value={lastworkingdate}
                                                        onChange={(e)=>setLastWorkingDate(formatDate(e))}
                                                        options={{
                                                            altInput: true,
                                                            altFormat: "F j, Y",
                                                            dateFormat: "Y-m-d"
                                                        }}
                                                    /> }
                                                </div>
                                            </Col>
                                        
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Address for further correspondence (Email/Telephone)</label>
                                                    <input type='text' 
                                                        className="form-control" 
                                                        value={addressforcorrespondencies} 
                                                        onChange={(e)=>setAddressforfurtherCorrespondecies(e.target.value)}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <div className="d-flex">
                                    <div className="flex-grow-1 ms-1">                                 
                                        <ul className="list-unstyled vstack gap-2 mb-0">
                                            <div className="d-grid gap-2">
                                                {(lastworkingdate != '') && (addressforcorrespondencies != '') && (
                                                    <Button color="primary" type="button" className="btn btnSubmitPlan" onClick={handleSubmitInterview}>
                                                        <i className="mdi mdi-clipboard-check-outline"/>{" "}
                                                            Initiate Exit Interview
                                                    </Button>
                                                )}
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                        </Row> 
                        )}
                        {(exitInterviews.length > 0) && (
                            <Row>
                            <Col>
                            <Card outline color="success" className="border">
                                <CardBody>
                                <CardTitle className="mb-4 text-white">
                                    
                                </CardTitle>
                                
                                <div className="text-center">
                                    <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                    </div>
                                    <div>
                                    <h5>Submitted</h5>
                                    <p className="text-muted">
                                            Exit Interview Submitted
                                    </p>
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <Link
                                    to={`/exit-interview-details/${exitInterviews[0].SystemId}`}
                                    className="btn btn-primary  btn-sm"
                                    >
                                    View More <i className="mdi mdi-arrow-right ms-1" />
                                    </Link>
                                </div>
                                </CardBody>
                            </Card>
                            </Col>
                            </Row>
                        )}

                    </Container>
                </div>
            </LoadingOverlay>
        );
    }

export default AddExitInterview;